import React from 'react'
import { connect } from 'react-redux';
import Ink from 'react-ink';
import * as general from '../constants/General'
import * as types from '../constants/Types'
import { getPos } from '../actions/dataActions'
import { getArticleGroupByArticle, getReceiptLinesToShow } from '../actions/receiptActions'
import PropTypes from 'prop-types'

class GraphicArticle extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      articles: []
    };
  }

  componentWillReceiveProps(nextProps) {
    clearInterval(this.state.intervalId);

    this.loadData(nextProps);
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  loadData(newProps) {
    let divArticles = [];
    let index = 0;

    const pos = newProps.getPos(newProps.posid);
    const showLines = newProps.getReceiptLinesToShow(newProps.lines);

    newProps.lines.sort((a, b) => (a.id - b.id)).filter(x => x.id >= showLines[0] && x.id <= showLines[1]).map((line) => {    
      if (line.linetype === types.ARTICLE_LINE) {
        fetch(`${general.API_URL_GET_ARTICLEGROUP_BY_ARTICLE}${line.itemid}`, {
          method: 'GET'
        })
          .then(response => response.json())
          .then(groups => {
            if (groups) {
              const exists = (pos !== null && pos.ArticleGroupId > 0)  ? groups.some(g => g.ArticleGroupId === pos.ArticleGroupId) : true;
              if (exists) {
                let style = {};
                if (line.keyid > 0) {
                  style.border = `2px solid white`;
                  style.backgroundImage = `url('${general.API_URL_ARTICLE_IMAGE}/${line.keyid}')`;
                  style.backgroundRepeat = `no-repeat`;
                  style.backgroundSize = `cover`;
                  style.backgroundPosition = `center`;
                } 

                for (var i = 0; i < line.quantity; i++) {
                  divArticles.push(
                    <div className="productionImage" key={index}>
                      <button className="itembutton" style={style}>
                        <Ink />
                        <p>{line.text}</p>
                      </button>
                    </div>)
                  
                  index++;
                }
              }
            }
          })
      }

      return true;
    })

    var intervalId = setInterval(() => { this.setState({ articles: divArticles })}, 100);
    this.setState({intervalId: intervalId});    
  }

  render() {
    return (
      <div id="overview">
        <div id="items" className="productionarticles">
          {this.state.articles}
        </div>
      </div>)
  }
}

GraphicArticle.propTypes = {
  getReceiptLinesToShow: PropTypes.func
}

function mapStateToProps(state) {
  return {
    lines: state.receiptState.receipt.lines,
    posid: state.generalState.posId
  }
}

export default connect(mapStateToProps, {
  getPos,
  getArticleGroupByArticle,
  getReceiptLinesToShow
})(GraphicArticle)



// WEBPACK FOOTER //
// src/components/GraphicArticle.jsx